import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function BookingBasicComponent ({jobs,shippingStatus,customers,Orders,selectedOrderBooking,onInnerBasicFormChange}: any) {
    return (
    <>
    <AccordionContainer
child={
  <><div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
     <InputContainer
               label="Order"
               labelField="MobilityOrderPId"
               list={Orders}
               onValueChange={(event: any) => {
                onInnerBasicFormChange(
                   event.target.value,
                   'Id'

                 );
               }}
               optionName='Choose Order'
               type="select"
               value={selectedOrderBooking?.Id}
               valueField="Id"
           />
      <InputContainer
        label="Invoice Number"
        name="InvoiceNumber"
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'InvoiceNumber'

          );
        } }
        type="text"
        value={selectedOrderBooking?.InvoiceNumber} />
        <InputContainer
                            label="Customer name"
                            labelField="RAPCustomerName"
                            list={customers}
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                event.target.value,
                                'CustomerId'
                              );
                            }}
                            optionName='Choose Customer'
                            type="select"
                            value={selectedOrderBooking?.CustomerId}
                            valueField="Id"
                        />
        
       <InputContainer
               label="Job"
               labelField="Message.TransportAgentName"
               list={jobs}
               onValueChange={(event: any) => {
                onInnerBasicFormChange(
                   event.target.value,
                   'JobId'

                 );
               }}
               optionName='Choose Job'
               type="select"
               value={selectedOrderBooking?.JobId}
               valueField="Message.Id"
           />
     
      <InputContainer
        label="Shipping Status"
        labelField="Text"
        list={shippingStatus}
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'ShippingStatusId'
          );
        } }
        optionName='Choose ShippingStatus'
        type="select"
        value={selectedOrderBooking?.ShippingStatusId}
        valueField="Value" />
    </div>
    <div className='col-span-full'>
        <InputContainer
        label="Description"
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'Description'
          );
        } }
        type="text"
        value={selectedOrderBooking?.Description} /></div></>
}
expandedPanel="basicInfo"
headerTitle="Basic Info"
/>
    </>
  )
}